var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchPreMatchMenu as fetchPreMatchMenuAction } from '../../../actions/creators/lines';
import { setActiveTab as setActiveTabAction } from '../../../actions/creators/sidebar';
import PreMatchHighlights from './PreMatchHighlights';
import PopularLive from './PopularLive';
import { fetchPopularMatches as fetchPopularMatchesAction, clearPopular as clearPopularAction } from '../../../actions/creators/popular';
var Popular = /** @class */ (function (_super) {
    __extends(Popular, _super);
    function Popular() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Popular.prototype.componentDidMount = function () {
        this.props.fetchPopularMatchesAction({ languageId: this.props.languageId, count: 5 });
        this.props.setActiveTabAction('live');
        localStorage.removeItem('lastExpandedLeague');
        localStorage.removeItem('expandedLeagues');
        localStorage.removeItem('backward');
        localStorage.removeItem('filterType');
    };
    Popular.prototype.componentWillReceiveProps = function (nextProps) {
        nextProps.languageId !== this.props.languageId &&
            this.props.fetchPopularMatchesAction({ languageId: nextProps.languageId, count: 5 });
    };
    Popular.prototype.componentWillUnmount = function () {
        this.props.clearPopularAction();
    };
    Popular.prototype.render = function () {
        var _a = this.props, fetching = _a.fetching, gridLocalization = _a.gridLocalization;
        return (_jsx(React.Fragment, { children: _jsxs("div", __assign({ className: 'content' }, { children: [_jsx(PopularLive, { gridLocalization: gridLocalization }), !fetching && _jsx(PreMatchHighlights, { section: 'popularMatches', gridLocalization: gridLocalization }), fetching && _jsx("div", __assign({ className: 'content' }, { children: _jsx("div", { className: 'please_wait' }) }))] })) }));
    };
    Popular.propTypes = {
        gridLocalization: PropTypes.object.isRequired,
        fetchPopularMatchesAction: PropTypes.func.isRequired,
        fetchPreMatchMenuAction: PropTypes.func.isRequired,
        languageId: PropTypes.number.isRequired,
        clearPopularAction: PropTypes.func.isRequired,
        fetching: PropTypes.bool.isRequired,
    };
    return Popular;
}(React.Component));
var mapStateToProps = function (state) { return ({
    fetching: state.application.getIn(['popularMatches', 'fetching']),
    languageId: state.application.get('languageId'),
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    fetchPopularMatchesAction: fetchPopularMatchesAction,
    clearPopularAction: clearPopularAction,
    fetchPreMatchMenuAction: fetchPreMatchMenuAction,
    setActiveTabAction: setActiveTabAction
}, dispatch); };
Popular = connect(mapStateToProps, mapDispatchToProps)(Popular);
export default Popular;



// WEBPACK FOOTER //
// ./src/components/grid/popular/index.js